var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFeed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.1,
    height: 17.993,
    viewBox: "0 0 16.1 17.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed_and_Nutrition",
    "data-name": "Feed and Nutrition",
    transform: "translate(-2.26 -0.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(2.26 0.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M21.226,15.166H16.271a.351.351,0,0,1,0-.7h4.263l-.606-.829a.352.352,0,0,1-.068-.207V5.634a.352.352,0,0,1,.07-.21l.6-.8H10.611l.6.8a.351.351,0,0,1,.07.21v.325a.351.351,0,0,1-.7,0V5.75l-.95-1.268a.351.351,0,0,1,.282-.562H21.224a.351.351,0,0,1,.282.562L20.56,5.75v7.562l.947,1.3a.351.351,0,0,1-.282.559Z",
    transform: "translate(-5.48 -2.231)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M9.916.9H21.232a.351.351,0,0,1,.351.351V2.935a.351.351,0,0,1-.351.351H9.916a.351.351,0,0,1-.351-.351V1.248A.351.351,0,0,1,9.916.9Zm10.965.7H10.266v.984H20.881Z",
    transform: "translate(-5.484 -0.897)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M26.253,25.177H21.3a.351.351,0,0,1,0-.7h4.6V23.49H21.3a.351.351,0,0,1,0-.7h4.955a.351.351,0,0,1,.351.351v1.687a.351.351,0,0,1-.354.351Z",
    transform: "translate(-10.507 -10.557)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M2.613,9.955H13.929a.351.351,0,0,1,.282.561l-.945,1.268v7.562l.947,1.3a.351.351,0,0,1-.284.559H2.613a.351.351,0,0,1-.283-.559l.95-1.3V11.785l-.95-1.268a.351.351,0,0,1,.283-.561Zm10.615.7H3.314l.6.8a.351.351,0,0,1,.07.21v7.793a.351.351,0,0,1-.068.208L3.3,20.5h9.93l-.606-.829a.352.352,0,0,1-.068-.207V11.668a.352.352,0,0,1,.07-.21Z",
    transform: "translate(-2.26 -4.894)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M2.614,6.936H13.93a.351.351,0,0,1,.351.351V8.974a.351.351,0,0,1-.351.351H2.614a.351.351,0,0,1-.351-.351V7.287a.351.351,0,0,1,.351-.351Zm10.965.7H2.964v.984H13.579Z",
    transform: "translate(-2.261 -3.562)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M13.933,31.216H9.68a.351.351,0,0,1,0-.7h3.9V29.53H2.966v.984h3.9a.351.351,0,1,1,0,.7H2.618a.351.351,0,0,1-.351-.351V29.18a.351.351,0,0,1,.351-.351H13.934a.352.352,0,0,1,.351.351v1.687a.351.351,0,0,1-.353.349Z",
    transform: "translate(-2.263 -13.223)",
    fill: "#AD040E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M13.821,16.163a.244.244,0,0,1-.207-.373l.017-.028a.861.861,0,0,0,.023-.813,1.4,1.4,0,0,1-.065.129,1.345,1.345,0,0,1-.94.656.244.244,0,1,1-.088-.48.854.854,0,0,0,.715-.826.244.244,0,0,1,.386-.194A1.352,1.352,0,0,1,14.053,16c-.008.015-.017.03-.026.044a.244.244,0,0,1-.208.116Z",
    transform: "translate(-4.453 -5.865)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M9.405,16.161a.244.244,0,0,1-.208-.115L9.171,16a1.352,1.352,0,0,1,.391-1.771.244.244,0,0,1,.386.194.854.854,0,0,0,.715.825.244.244,0,0,1-.085.48,1.345,1.345,0,0,1-.94-.656,1.307,1.307,0,0,1-.065-.129.862.862,0,0,0,.024.813l.017.028a.244.244,0,0,1-.207.373Z",
    transform: "translate(-2.971 -5.864)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M15.287,18.043a.244.244,0,0,1-.018-.488.64.64,0,0,0,.391-.142.944.944,0,0,0,.132-.711.946.946,0,0,0-.711.132.377.377,0,0,0-.065.091.244.244,0,0,1-.432-.227.853.853,0,0,1,.153-.209,1.552,1.552,0,0,1,1.324-.236.244.244,0,0,1,.18.18A1.551,1.551,0,0,1,16,17.756a1.072,1.072,0,0,1-.7.283h-.018v0Z",
    transform: "translate(-5.427 -6.751)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M8.048,18.046h-.02a1.071,1.071,0,0,1-.7-.283,1.549,1.549,0,0,1-.236-1.324.244.244,0,0,1,.18-.18,1.553,1.553,0,0,1,1.324.236.851.851,0,0,1,.153.211.244.244,0,0,1-.432.226.378.378,0,0,0-.066-.091.94.94,0,0,0-.711-.132.946.946,0,0,0,.132.711.639.639,0,0,0,.391.142.244.244,0,0,1-.018.488v0Z",
    transform: "translate(-2.108 -6.754)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M11.928,23.559H8.663a.977.977,0,0,1-.976-.976v-.268a.977.977,0,0,1,.976-.976h3.265a.977.977,0,0,1,.977.976v.268a.975.975,0,0,1-.976.976ZM8.663,21.827a.488.488,0,0,0-.487.487v.268a.488.488,0,0,0,.487.487h3.265a.487.487,0,0,0,.487-.487v-.268a.488.488,0,0,0-.487-.487Z",
    transform: "translate(-2.395 -9.021)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M13.558,19.757a.244.244,0,0,1-.244-.244V19.2a.244.244,0,0,1,.488,0v.317a.244.244,0,0,1-.244.244Z",
    transform: "translate(-4.878 -7.972)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M10.767,19.748a.244.244,0,0,1-.244-.244v-.317a.244.244,0,0,1,.488,0V19.5a.245.245,0,0,1-.244.245Z",
    transform: "translate(-3.646 -7.963)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M14.066,23.3h-.022l-.024,0L14,23.289l-.022-.008-.022-.011-.021-.012-.019-.014-.018-.016a.245.245,0,0,1-.03-.037l-.012-.021-.011-.022a.182.182,0,0,1-.008-.022.19.19,0,0,1-.006-.023c0-.008,0-.016,0-.024s0-.016,0-.024v-.024a.1.1,0,0,1,0-.024.2.2,0,0,1,.006-.023.205.205,0,0,1,.018-.044.237.237,0,0,1,.06-.073.245.245,0,0,1,.04-.027l.022-.011L14,22.822l.023-.006.024,0a.23.23,0,0,1,.048,0l.024,0,.023.006.022.008.022.011.021.012.019.014.018.016.016.018.014.019a.157.157,0,0,1,.012.021.226.226,0,0,1,.01.022.229.229,0,0,1,.008.022c0,.008,0,.015.006.023s0,.016,0,.024,0,.016,0,.024a.255.255,0,0,1,0,.047.083.083,0,0,1-.006.023.219.219,0,0,1-.008.022l-.01.022-.012.021-.014.019-.016.018-.018.016-.019.014-.021.012-.022.011-.022.008-.023.006a.256.256,0,0,1-.047.005Z",
    transform: "translate(-5.103 -9.671)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M10.26,23.291a.238.238,0,0,1-.047,0,.087.087,0,0,1-.023-.006l-.023-.008-.021-.011-.021-.012-.019-.014-.018-.016-.016-.018-.014-.02a.175.175,0,0,1-.012-.021l-.011-.022c0-.008-.006-.015-.008-.022a.227.227,0,0,1-.006-.023.288.288,0,0,1,0-.047c0-.008,0-.016,0-.024a.194.194,0,0,1,0-.024.076.076,0,0,1,.006-.023.061.061,0,0,1,.008-.022.231.231,0,0,1,.011-.022l.012-.021.014-.019.016-.018.018-.016.019-.014.021-.012.021-.011.023-.008.023-.006.024,0a.246.246,0,0,1,.2.071l.016.018.014.019.012.021.011.022c0,.008.006.015.008.022a.194.194,0,0,1,.009.047c0,.008,0,.016,0,.024a.216.216,0,0,1,0,.024.134.134,0,0,1,0,.024.189.189,0,0,1-.006.023.223.223,0,0,1-.008.022.2.2,0,0,1-.011.022l-.012.021-.014.02-.016.018-.018.016-.019.014-.021.012-.022.011-.022.008-.023.006c-.008,0-.016,0-.023,0Z",
    transform: "translate(-3.422 -9.667)",
    fill: "#AD040E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M8.653,19.57a.244.244,0,0,1-.244-.244v-1.4a1.84,1.84,0,0,1,1.839-1.839h.733a1.84,1.84,0,0,1,1.839,1.839v.129a.244.244,0,0,1-.488,0v-.129a1.351,1.351,0,0,0-1.352-1.352h-.732A1.352,1.352,0,0,0,8.9,17.923v1.4a.244.244,0,0,1-.243.244Z",
    transform: "translate(-2.713 -6.702)",
    fill: "#AD040E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFeed);
export default __webpack_public_path__ + "static/media/activeFeed.9f99dd78c7f0d7f9297b846c7707661c.svg";
export { ForwardRef as ReactComponent };